import { PhoneInput } from 'react-international-phone';
import { useState } from 'react';

export const FormInput = ({
  type = 'text',
  value,
  onChange,
  haveError = false,
  id,
  labelKey,
  label,
  placeholder,
  maxLength = 100,
  country = '',
  disabled = false,
}: {
  type?: string;
  value: string;
  onChange: (newValue: string) => void;
  haveError?: boolean;
  id?: string;
  labelKey: string;
  label: string;
  placeholder: string;
  maxLength?: number;
  country?: string;
  disabled?: boolean;
}) => {
  const [touched, setTouched] = useState(false);
  type FormErrors = {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    [key: string]: string; // Allow dynamic indexing
  };
  const formErrors: FormErrors = {
    firstName: 'Enter a valid first name',
    lastName: 'Enter a valid last name',
    email: 'Enter a valid email address',
    phone: 'Enter a valid phone number',
    postcode: 'Enter a valid postal code',
    // Add more fields as needed
  };
  return (
    <>
      <label
        className={`text-[13px] block tracking-wide mb-2 after:content-['*'] after:text-[#de2100] after:ml-[2px] uppercase ${
          touched && haveError ? 'text-[#de2100]' : 'text-gray-700'
        }`}
        htmlFor={id}>
        {label}
      </label>
      {type === 'phone' ? (
        <PhoneInput
          defaultCountry={country.toLowerCase()}
          value={value}
          onChange={(phone) => onChange(phone)}
          placeholder={placeholder}
          hideDropdown={true}
          disableDialCodeAndPrefix={true}
          showDisabledDialCodeAndPrefix={true}
          inputProps={{ onBlur: () => setTouched(true) }}
          className={`${
            touched && haveError ? 'border-b border-b-[#de2100]' : 'border-none'
          }`}
          disabled={disabled}
          disableFocusAfterCountrySelect={true}
        />
      ) : (
        <input
          className={`text-[18px] appearance-none block w-full py-1 rounded-none leading-tight outline-none ${
            touched && haveError ? 'border-b border-b-[#de2100]' : 'border-none'
          }${
            disabled
              ? ' bg-[#eeeeee] text-gray-400 px-2'
              : ' bg-white text-gray-700'
          }`}
          id={id}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
            setTouched(true);
          }}
          maxLength={maxLength}
          onBlur={() => setTouched(true)}
          disabled={disabled}
        />
      )}
      {touched && haveError && (
        <p className="text-enph-red-functional text-[13px] pt-[5px]">
          {formErrors[labelKey]}
        </p>
      )}
    </>
  );
};
